import React, { useState } from "react";

const ProductCard = ({ product, onEdit, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    productName: product.productName,
    cost: product.cost,
    description: product.description,
  });

  // ⭐ FIX: Support Cloudinary `imageUrls` array OR old `imageUrl`
  const image =
    product.imageUrl ||
    (Array.isArray(product.imageUrls) ? product.imageUrls[0] : null);

  // If no essential values exist → do not render card
  if (!product || !product.productName || !product.cost || !image) {
    return null;
  }

  const handleSave = () => {
    onEdit(product._id, editData);
    setIsEditing(false);
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "10px",
        padding: "12px",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.15)",
      }}
    >
      {/* PRODUCT IMAGE */}
      <img
        src={image}
        alt={product.productName}
        style={{
          width: "100%",
          height: "220px",
          objectFit: "cover",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      />

      {/* PRODUCT NAME */}
      {isEditing ? (
        <input
          type="text"
          value={editData.productName}
          onChange={(e) =>
            setEditData({ ...editData, productName: e.target.value })
          }
          style={{ width: "100%", marginBottom: "6px" }}
        />
      ) : (
        <h3 style={{ fontSize: "18px", marginBottom: "6px" }}>
          {product.productName}
        </h3>
      )}

      {/* PRODUCT COST */}
      {isEditing ? (
        <input
          type="number"
          value={editData.cost}
          onChange={(e) =>
            setEditData({ ...editData, cost: e.target.value })
          }
          style={{ width: "100%", marginBottom: "6px" }}
        />
      ) : (
        <p style={{ fontSize: "16px", marginBottom: "6px" }}>
          ₹ {product.cost}
        </p>
      )}

      {/* PRODUCT DESCRIPTION */}
      {isEditing ? (
        <textarea
          value={editData.description}
          onChange={(e) =>
            setEditData({ ...editData, description: e.target.value })
          }
          style={{ width: "100%", marginBottom: "6px" }}
        />
      ) : (
        <p style={{ fontSize: "14px", color: "#666", marginBottom: "10px" }}>
          {product.description}
        </p>
      )}

      {/* ACTION BUTTONS */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {isEditing ? (
          <>
            <button
              onClick={handleSave}
              style={{
                background: "green",
                color: "white",
                padding: "6px 10px",
                borderRadius: "6px",
                border: "none",
              }}
            >
              Save
            </button>
            <button
              onClick={() => setIsEditing(false)}
              style={{
                background: "gray",
                color: "white",
                padding: "6px 10px",
                borderRadius: "6px",
                border: "none",
              }}
            >
              Cancel
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => setIsEditing(true)}
              style={{
                background: "#007bff",
                color: "white",
                padding: "6px 10px",
                borderRadius: "6px",
                border: "none",
              }}
            >
              Edit
            </button>
            <button
              onClick={() => onDelete(product._id)}
              style={{
                background: "red",
                color: "white",
                padding: "6px 10px",
                borderRadius: "6px",
                border: "none",
              }}
            >
              Delete
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
